import axios from 'axios'

export default {
    getTujuan(){
        return axios.get('/tujuan')
            .then(response => {
                return response.data
            })
    },
    getTujuanDataSource(params){
        return axios.get('/tujuan/datasource', {params})
            .then(response => {
                return response.data
            })
    },
    getTujuanbyID(id){
        return axios.get('/tujuan/' + id)
            .then(response => {
                return response.data
            })
    },    
    createTujuan(formdata){
        return axios.post('/tujuan', formdata)
            .then(response => {
                return response.data
            })
    },
    updateTujuan(id,formdata){
        return axios.put('/tujuan/' + id, formdata)
            .then(response => {
                return response.data
            })
    },
    deactivateTujuan(id){
        return axios.put('/tujuan/' + id + '/deactivate')
            .then(response => {
                return response.data
            })
    },
    reactivateTujuan(id){
        return axios.put('/tujuan/' + id + '/reactivate')
            .then(response => {
                return response.data
            })
    },
    
}